import {eTipoPermissao} from '@/enums/ePermissoes';
export default [
 {
  description: 'Cargo Comissionado',
  path: '/pessoal/pescargocomissionado',
  name: 'pescargocomissionado',
  component: () => import('@/views/pessoal/pescargocomissionado/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.CARGOCOMISSIONADONOVO_MENU_1400700899],
  },
  goesToMenu: true,
 },
 {
  description: 'Cadastro de Cargo Comissionado',
  path: '/pessoal/pescargocomissionado/cadastro/:id?',
  parent: 'pescargocomissionado',
  name: 'pescargocomissionado_create',
  component: () => import('@/views/pessoal/pescargocomissionado/InclusaoEdicao.vue'),
  meta: {
   permissions: [eTipoPermissao.CARGOCOMISSIONADONOVO_MENU_1400700899],
  },
  goesToMenu: true,
 },
]
